var _defs, _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _polygon, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack166({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 4,
    y: 10.55,
    width: 8,
    height: 1,
    rx: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 3.51,
    cy: 6.94,
    rx: 2.51,
    ry: 2.49
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 3.51,
    cy: 6.94,
    rx: 1.08,
    ry: 1.07
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 12.49,
    cy: 6.94,
    rx: 2.51,
    ry: 2.49
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 12.49,
    cy: 6.94,
    rx: 1.08,
    ry: 1.07
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.65 10.55 5.54 8.46 5.03 8.96 6.63 10.55 7.65 10.55"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "9.37 10.55 10.97 8.96 10.46 8.46 8.35 10.55 9.37 10.55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack166);
export default __webpack_public_path__ + "static/media/Symbolpack_1_66.0f0299fd6b62a54d2768ca5d02502d95.svg";
export { ForwardRef as ReactComponent };